export const MANUAL_TIME_UPDATE_EVENT_TYPE = 'manualtimeupdate';
export const manualTimeUpdateEvent = new Event(MANUAL_TIME_UPDATE_EVENT_TYPE);

export const FONT_SIZE_TO_LETTER_SPACING_RATIO = -1 / 250;
export const FONT_SIZE_TO_OUTLINE_WIDTH_RATIO = 1 / 6.5;
